import * as Yup from "yup";
import {
  emailRule,
  fileValidationSchema,
  passwordRule,
  requiredDate,
  requiredFile,
  requiredNumber,
  requiredString,
} from "../../../utils/validation/comonValidation";

const maritalFieldRule = (fieldName: string, message: string) =>
  Yup.string().when(
    "maritalStatus",
    (maritalStatus: Array<"married" | "single">, schema) => {
      if (maritalStatus[0] === "married") {
        return schema.required("Spouse name is  required");
      }
      return schema.notRequired();
    }
  );

// Login Schema
export const loginValidationSchema = Yup.object().shape({
  email: emailRule,
  password: requiredString("Please enter your password"),
});

// Register Schema
export const registerValidationSchema = Yup.object().shape({
  firstName: requiredString("First name is required"),
  lastName: requiredString("Last name is required"),
  email: emailRule,
  password: passwordRule,
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords must match")
    .required("Confirm password is required"),
  jobType: requiredString("Job type is required"),
  qualificationType: requiredString("Qualification type is required"),
  gender: requiredString("Gender is required"),
  dateOfJoining: requiredDate("Date of joining is required"),
});

// User Official Information
export const userOfficialInformationSchema = Yup.object().shape({
  employeeId: requiredString("Employee Id is required"),
  name: requiredString("Name is required"),
  email: emailRule,
  mobileNumber: requiredNumber("Mobile No. is required"),
  department: requiredString("Department is required"),
  designation: requiredString("Designation is required"),
  center: requiredString("Center is required"),
  dateOfJoining: requiredString("Date Of Joining is required"),
  roleType: requiredString("Employee Role is required"),
  // profileImage: fileValidationSchema,
});

// User Family Information
export const userFamilyInformationSchema = Yup.object().shape({
  fatherName: requiredString("Father name is required"),
  fatherContact: requiredString("Father Contact No. is required"),
  fatherOccupation: requiredString("Father Occupation is required"),
  motherName: requiredString("Mother name is required"),
  motherOccupation: requiredString("Mother Occupation is required"),
  motherContact: requiredString("Mother Contact No. is required"),
  maritalStatus: requiredString("Marital status is required"),
  anniversaryDate: maritalFieldRule(
    "anniversaryDate",
    "Married anniversary date is required"
  ),
  spouseName: maritalFieldRule("spouseName", "Spouse name is required"),
  spouseContact: Yup.string().when(
    "maritalStatus",
    (maritalStatus: Array<"married" | "single">, schema) => {
      if (maritalStatus[0] === "married") {
        return schema.required("Spouse contact is  required");
      }
      return schema.notRequired();
    }
  ),
  spouseOccupation: Yup.string().when(
    "maritalStatus",
    (maritalStatus: Array<"married" | "single">, schema) => {
      if (maritalStatus[0] === "married") {
        return schema.required("Spouse occupation is  required");
      }
      return schema.notRequired();
    }
  ),
});

// User Personal Information
export const userPersonalInformationSchema = Yup.object().shape({
  aadharCard: requiredFile("Aadhar card photo is required"),
  panCard: requiredFile("Pan card photo is required"),
  // contactNumber: requiredString("Contact no. is required"),
  alternateContact: requiredString("Alternate Contact no. is required"),
  dob: requiredString("Date of birth is required"),
  gender: requiredString("Gender is required"),
  currentState: requiredString("State is required"),
  currentCity: requiredString("City is required"),
  currentPincode: requiredString("Pincode is required"),
  currentStreet: requiredString("Street is required"),
  permanentStreet: requiredString("Permanent street is required"),
  permanentPincode: requiredString("Permanent pincode is required"),
  permanentCity: requiredString("Permanent city is required"),
  permanentState: requiredString("Permanent State is required"),
  aadharNumber: Yup.string()
    .min(12, "Aadhar no. must be at least 12 digits")
    .required("Aadhar no. is required"),
  panNumber: Yup.string()
    .min(10, "Pan no. must be at least 10 digits")
    .required("Pan no. is required"),
  alternateEmail: requiredString("Alternate email is required"),
});

export const userEducationInformationSchema = Yup.object().shape({
  institute_name: requiredString("School or Institute name is required"),
  board: requiredString("Board is required"),
  specialization: requiredString("Specialization is required"),
  start_year: requiredString("Start year is required"),
  end_year: requiredString("End year is required"),
  percentage: requiredString("Percentage is required"),
  course_id: Yup.number()
    .required("Course is required")
    .test("not-zero", "Course is required", (value) => value !== 0),
  certificate: fileValidationSchema.required("Certificate is required"),
});

export const userWorkInformationSchema = Yup.object().shape({
  companyName: requiredString("Company name is required"),
  designation: requiredString("Designation is required"),
  startDate: requiredDate("Start date is required"),
  endDate: requiredDate("End date is required"),
  companyAddress: requiredString("Company Address is required"),
  offerLetter: fileValidationSchema,
  relievingLetter: fileValidationSchema,
});

export const aprroveLeaveSchema = Yup.object().shape({
  leave_id: requiredString("Leave Id is required"),
  comment: requiredString("Comment is required"),
  action: requiredString("Action is required"),
});

export const approveAttendanceSchema = Yup.object().shape({
  action: requiredString("Action is required"),
  comment: requiredString("Comment is required"),
});

export const financialInformationSchema = Yup.object().shape({
  accountHolderName: requiredString("Account holder name is required"),
  bankName: requiredString("Bank name is required"),
  ifscCode: requiredString("IFSC code is required"),
  accountNumber: requiredString("Account no. is required"),
  registeredMobileNo: requiredString("Registerd Mobile no. is required"),
  registeredEmail: requiredString("Registerd email is required"),
  bankProof:requiredString("Bank Proof is required")
});

// Reset Password Schema
export const resetPasswordValidationSchema = Yup.object().shape({
  password: requiredString("Please enter your password").min(
    8,
    "Password must be at least 6 characters long"
  ),
  password_confirmation: requiredString(
    "Please enter your confirm password"
  ).oneOf([Yup.ref("password")], "Passwords do not match"),
});


